module.exports = __webpack_public_path__ + "36490deb3548c24a4cf144a4760966a4.pdf";